import config from '@/config'
export  default [
  {
    title: "活动信息",
    modules: [
      {
        icon: "BankOutlined",
        name: "活动首页",
        type:'index',
        defaultData:{
          style:{
            backgroundImage:'web_base_assets/scan/background_default.png',
            backgroundColor:"#fff",
          },
          params:{
            title:"扫码页",
          }
        }
      },
      {
        icon: "DollarCircleOutlined",
        name: "领奖结果",
        type:'award',
        defaultData:{
          win:{
            integralTips:"已到账,可兑换礼品",
            giftTips:"已到会员中心,前去领取",
            redTips:"已到账,请返回微信查看",
            rankingKey:['red','point'],
            btnKey:['cloud','center'],
            bottom:{
              shop:{
                name:"前往云店商城",
                is_show:true,
                name_color:"#000",
                background_color:'#fff'
              },
              center:{
                name:"前往会员中心",
                is_show:true,
                name_color:"#000",
                background_color:'#fff'
              }
            }
          },
          no_win:{
            tips:'您没有获得奖励,再接再励!',
            text_color:"#000",
            backgroundImage:'web_base_assets/scan/background_default.png',
            backgroundColor:"#fff",
            rankingKey:['red','point'],
            btnKey:['cloud','center']
          },
          repeat_win:{
            text_color:"#000",
            backgroundImage:'web_base_assets/scan/background_default.png',
            backgroundColor:"#fff",
            rankingKey:['red','point'],
            btnKey:['cloud','center']
          },
          repeat_no_win:{
            tips:"您没有获得奖励,再接再励",
            text_color:"#000",
            backgroundImage:'web_base_assets/scan/background_default.png',
            backgroundColor:"#fff",
          },
          received:{
            tips:"您没有获得奖励,再接再励",
            text_color:"#000",
            backgroundImage:'web_base_assets/scan/background_default.png',
            backgroundColor:"#fff",
          },
          no_started:{
            ban:"当前页面仅用于预览前端效果,暂不支持自定义设置"
          },
          end:{
            ban:"当前页面仅用于预览前端效果,暂不支持自定义设置"
          },
          no_open:{
            ban:"当前页面仅用于预览前端效果,暂不支持自定义设置"
          }
        }
      },
    ],
  },
  {
    title: "扫码信息",
    modules: [
      {
        icon: "SearchOutlined",
        name: "防伪验证",
        type:'search',
        defaultData:{
          type:'search',
          name:'搜索框',
          params:{
            placeholder:'搜索商品',
            scanShow:1
          },
          style:{
            position:'static',
            themeColor:'#F85F24'
          }
        } 
      },
      {
        icon: "ColumnHeightOutlined",
        name: "企业信息",
        type:'blank',
        defaultData:{
          type:'blank',
          name:'空白条',
          params:{},
          style:{
            height:'20'
          }
        }
      },
      {
        icon: "AppstoreOutlined",
        name: "指纹鉴真",
        type:'nav',
        defaultData:{
          type:'nav',
          name:'导航',
          data:[
            {imgUrl:config.oss[process.env.VUE_APP_type]+'user_icon.png',linkUrl:"",name:'个人中心'},
            {imgUrl:config.oss[process.env.VUE_APP_type]+'goods_icon.png',linkUrl:"",name:'好物榜'},
            {imgUrl:config.oss[process.env.VUE_APP_type]+'kill_icon.png',linkUrl:"",name:'限时秒杀'},
            {imgUrl:config.oss[process.env.VUE_APP_type]+'new_icon.png',linkUrl:"",name:'新品上架'},
          ],
          params:{
            interval: "2800"
          },
          style:{
            btnColor: "#ffffff",
            btnShape: "round"
          }
        }
      },
      {
        icon: "GiftOutlined",
        name: "商品信息",
        type:'guessLove',
        defaultData:{
          type:'guessLove',
          name:'礼品推荐',
          data:[],
          params:{
            rules:1
          },
          style:{
            paddingTB:10,
            paddingLR:10,
            class:'full',
          }
        }
      },
      {
        icon: "NotificationOutlined",
        name: "加群模板",
        type:'notice',
        defaultData:{
          type:'notice',
          name:'公告组',
          params:{
            content:'这是一条自定义内容',
          },
          style:{
            backgroundColor:'#ffffff',
            textColor:'#000000',
            paddingTB:10,
            paddingLR:15,
          }
        } 
      },
      {
        icon: "NotificationOutlined",
        name: "溯源信息",
        type:'notice',
        defaultData:{
          type:'notice',
          name:'公告组',
          params:{
            content:'这是一条自定义内容',
          },
          style:{
            backgroundColor:'#ffffff',
            textColor:'#000000',
            paddingTB:10,
            paddingLR:15,
          }
        } 
      },
    ],
  }
]